<template>
  <div class="header">
    <div class="leftBar">
      <span class="date">{{ nowDate1 }}</span>
      <span class="week">{{ DateToday }}</span>
      <span class="time num">{{ nowTime }}</span>
      <div>
        <span class="flex cursor" @click="weatherClick">
          <img width="20px" :src="form.code" />
          <span>{{ form.sk_s }}</span>
          <span>{{ form.sk_t }}°C</span>
        </span>
      </div>
    </div>

    <div class="rightBar">
      <div class="warn flex">
        <div>
          <ul
            class="new-list"
            @mouseenter="Stop()"
            @mouseleave="Up()"
            ref="newList"
          >
            <li
              class="notice"
              v-for="(item, index) in list"
              :key="index"
              :title="item.info"
              :class="{ anim: animate }"
              @click="warnClick"
            >
              <span>[{{ item.date }}]</span>
              {{ item.info }}
            </li>
          </ul>
        </div>
        <img
          style="margin-left: .09rem;margin-right: .12rem; padding: 3px 0"
          src="~images/index/home/robot.png"
        />
        <a
          class="yyzx"
          :href="yyurl"
          title="茂名市荔枝优势产区产业园荔枝产业大数据中心"
          v-if="fromPath !== 'newIndex'"
        >
          <img src="~images/index/home/yyxt.png" alt="" />
          <p>应用中心</p>
        </a>
      </div>
    </div>
    <!-- 右侧按钮 -->
    <slot name="rightBtn"></slot>

    <a class="click-area" @click="goHome"></a>
    <!-- <a class="click-area" href="http://123.57.29.55:81/home"></a> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  getCodeByJwd,
  getNewWarningByCategory,
  // getScreenV2FindWlwWarningByCategoryAndDateNum
} from "@/api/home";
export default {
  computed: {
    ...mapGetters(["qxzInfo", "fromPath", "clientid"]),
    yyurl() {
      if (process.env.NODE_ENV === "prod1") {
        return "/mm/m-screen/zt/zlcy/ywtg/index.html";
      } else if (this.clientid === "20008") {
        return window.__config.VUE_APP_IMG_URL + "/ywtg";
      } else {
        return "http://36.133.180.35:8081/";
      }
    },
  },
  data() {
    return {
      nowTime: this.$formatDate(new Date(), "hh:mm:ss"),
      nowDate1: this.$formatDate(new Date(), "yyyy年MM月dd日"),
      weekData: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      //   list: [{ info: "强冷空气来袭，请及时做好水果防寒工作。" }],
      list: [],
      animate: false,
      scrollTimer: null,
      form: {},
      DateToday: "",
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.nowTime = this.$formatDate(new Date(), "hh:mm:ss");
    }, 1000);
    let mydate = new Date().getDay();
    this.DateToday = this.weekData[mydate];
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      if (JSON.stringify(this.qxzInfo) == "{}") {
        getCodeByJwd({ code: "441700" }).then((res) => {
          if (res.content) {
            this.$store.dispatch("drawer/setQxzInfo", res.content);
            this.form = this.qxzInfo.sk;
            this.form.code = require("images/index/weather/wether/" +
              this.qxzInfo.sk.i);
            this.weatherObj = this.qxzInfo;
            this.dayList = this.weatherObj.f_rows.slice(0, 7);
            this.dayList.map((v) => {
              v.code = require("images/index/weather/wether/" + v.i);
            });
          }
        });
      } else {
        this.form = this.qxzInfo.sk;
        this.form.code = require("images/index/weather/wether/" +
          this.qxzInfo.sk.i);
        this.weatherObj = this.qxzInfo;
        this.dayList = this.weatherObj.f_rows.slice(0, 7);
        this.dayList.map((v) => {
          v.code = require("images/index/weather/wether/" + v.i);
        });
      }
      // 预警信息
      let params = {
        category: "qx",
        num: 5,
      };
      getNewWarningByCategory(params).then((res) => {
        this.list = res.data.map((e) => {
          e.date = this.$formatDate(e.date, "yyyy-MM-dd hh:mm");
          return e;
        });
        this.$nextTick(() => {
          this.ScrollUp();
        });
      });
      // getScreenV2FindWlwWarningByCategoryAndDateNum({ dateNum: 7 }).then(
      //   res => {
      //     this.list = res.data;
      //     this.ScrollUp();
      //   }
      // );
    },
    // handleClick() {
    //   this.$router.push('/index');
    //   this.$emit('barChoose');
    // },
    weatherClick() {
      this.$store.dispatch("drawer/setRightComponent", "weatherDrawer");
    },
    warnClick() {
      this.$store.dispatch("drawer/setRightComponent", "warnDrawer");
    },
    ScrollUp() {
      // this.scrollTimer = setInterval(() => {
      //   this.animate = true;
      //   setTimeout(() => {
      //     this.list.push(this.list[0]);
      //     this.list.shift();
      //     this.animate = false;
      //   }, 500);
      // }, 3000);
      this.scrollTimer = setInterval(() => {
        this.animate = true;
        setTimeout(() => {
          if (this.$refs.newList)
            this.$refs.newList.append(this.$refs.newList.firstChild);
          this.animate = false;
        }, 1000);
      }, 5000);
    },
    //鼠标移上去停止
    Stop() {
      clearInterval(this.scrollTimer);
    },
    Up() {
      if (this.list.length > 0) {
        this.ScrollUp();
      }
    },
    goHome() {
      if (this.fromPath === "newIndex") {
        return;
      } else {
        this.$router.push("/index");
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.header
  position absolute
  width 100%
  z-index 7
  height .47rem
  background url('~images/components/titlebg.png') no-repeat center
  background-size 100% 100%

  .cursor
    cursor pointer

  .leftBar
    display flex
    align-items center
    position relative
    top .08rem
    width 27%
    color #fff
    font-size .07rem
    padding-left 5px

    span
      margin 0 5px

    .time
      font-size .12rem

  .headTitle
    height 88%
    position absolute
    top 0
    left 50%
    transform translateX(-50%)
    cursor pointer

  .rightBar
    position absolute
    right 0
    color #fff
    top 0
    width 27%

  .warn
    position relative
    top 10px
    float right
    cursor pointer

    div
      border 1px solid #468B9E
      padding 5px .23rem 5px .08rem
      border-radius 7px 0 7px 7px
      height 44px
      width 20vw
      box-sizing border-box
    img
      width 30px

    .yyzx
      display block
      width 64px
      margin-right .17rem
      text-align center
      >img
        width 30px
        margin 0 auto
      >p
        color #fff
        font-size 12px

  .new-list
    overflow hidden
    cursor pointer
    height 100%

  .anim
    animation animated 1s linear forwards

  @keyframes animated
    from
      transform translateY(0)

    to
      transform translateY(-100%)

  .notice
    width 100%
    display -webkit-box
    -webkit-box-orient vertical
    -webkit-line-clamp 2
    overflow hidden
    color red
    font-size 15px
    height 34px
    line-height 34px


  .click-area
    position absolute
    left 37%
    top 0
    width 26%
    height 80%
    display block
    opacity 0
    cursor pointer
</style>
